exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".changeapp[data-v-3eff140a]{padding-top:20px;padding-right:20px}.changeapp .btn[data-v-3eff140a]{width:100%;text-align:center}\n", ""]);

// exports
